<div class="fixed bottom-2 left-2 z-50">
  <button mat-mini-fab color="primary" (click)="showAppInfo()">
    <mat-icon>info</mat-icon>
  </button>
</div>
